import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { CheckCircle2, CalendarClock, MessageSquare, Upload } from "lucide-react";
import { consultApi } from "../lib/consult";
import { formatINR } from "../lib/constants";

export default function ConsultationSuccess() {
    const { bookingId } = useParams();
    const [b, setB] = useState(null);

    useEffect(() => {
        consultApi.get(`/me/bookings/${bookingId}`).then(({ data }) => setB(data.booking)).catch(() => {});
    }, [bookingId]);

    return (
        <div className="pt-28 md:pt-32 pb-24" data-testid="consultation-success-page">
            <div className="mx-auto max-w-3xl px-6 md:px-10">
                <CheckCircle2 className="w-10 h-10 text-lime" />
                <h1 className="mt-6 font-display text-4xl sm:text-5xl uppercase tracking-tight">
                    Your consultation is booked
                </h1>
                <p className="mt-4 text-zinc-400 max-w-xl">
                    Your intake form has reached your consultant. You will receive a payment link and appointment
                    reminder on WhatsApp and email.
                </p>

                {b && (
                    <div className="mt-9 border border-white/10 bg-bg1 p-6" data-testid="success-summary">
                        <div className="mono text-[10px] tracking-[0.22em] text-zinc-500">CONSULTATION ID</div>
                        <div className="font-display text-3xl text-gold mt-1" data-testid="success-consultation-id">{b.consultation_id}</div>
                        <div className="mt-5 space-y-2.5 text-sm">
                            <Row k="Plan" v={b.package_name} />
                            <Row k="Consultant" v={b.doctor_name} />
                            <Row k="Appointment" v={`${b.slot_date} · ${b.slot_label?.split(" ").slice(1).join(" ")} IST`} />
                            <Row k="Amount" v={formatINR(b.amount)} />
                            <Row k="Payment" v={b.payment_status === "paid" ? "Received" : "Link will be shared by our team"} />
                        </div>
                    </div>
                )}

                <div className="mt-8 grid sm:grid-cols-3 gap-3">
                    <Next icon={Upload} title="Upload reports" body="Add prescriptions, lab reports or photos." />
                    <Next icon={CalendarClock} title="Reschedule anytime" body="Move your slot from My Consultations." />
                    <Next icon={MessageSquare} title="Message your doctor" body="Ask follow-up questions in the secure thread." />
                </div>

                <div className="mt-9 flex flex-wrap gap-3">
                    <Link to={`/account/consultations/${bookingId}`} data-testid="success-open-consultation"
                        className="btn-pill btn-primary">Open my consultation</Link>
                    <Link to="/shop" data-testid="success-shop-link" className="btn-pill btn-secondary">Browse products</Link>
                </div>
            </div>
        </div>
    );
}

const Row = ({ k, v }) => (
    <div className="flex items-start justify-between gap-6">
        <span className="text-zinc-500">{k}</span><span className="text-white text-right">{v || "—"}</span>
    </div>
);

const Next = ({ icon: Icon, title, body }) => (
    <div className="border border-white/10 bg-bg1 p-5">
        <Icon className="w-4 h-4 text-gold" />
        <div className="mt-3 font-display text-lg uppercase tracking-tight">{title}</div>
        <p className="mt-1.5 text-xs text-zinc-400 leading-relaxed">{body}</p>
    </div>
);
